import React from 'react';
import AccordionReact from './components/AccordionReact';
import Layout from './partials_refactored/Layout';
import { testPageContent as content } from './testPageContent';
import { GeneralComponentsStyle } from './pages/styles/GeneralComponentsStyle';

const TestPage = () => {
  return (
    <Layout>
      <GeneralComponentsStyle>
        <AccordionReact {...content.accordionReact} />
      </GeneralComponentsStyle>
    </Layout>
  );
};

export default TestPage;
